<template>
  <div class="page">
    <report-cover image="cover.jpg" headline="Außergewöhnlich<br> erfolgreich" @cover-change="coverChange"/>
    <div class="container">
      <h5>Unsere an starken Werten orientierte Unternehmensstrategie hat sich auch unter den außergewöhnlichen Rahmenbedingungen des Jahres 2020 bewährt. Die enercity-Bilanz weist Umsatzerlöse in Höhe von 3,7 Milliarden Euro aus, eine Steigerung um etwa 20 Prozent im Vergleich zum Vorjahr. Das Ergebnis vor Steuern fällt mit 100,2 Millionen Euro etwas niedriger aus als im Vorjahr, die Gründe hierfür liegen in den Effekten der Corona-Pandemie.</h5>
      <h2>In kommunaler Hand: <br>Die enercity-Eigentümerstruktur</h2>
      <div class="row">
        <div class="col">
          <div class="image-box">
            <img src="../assets/images/report/stats.jpg" alt="">
          </div>
        </div>
        <div class="col">
          <p>Stadt und Region Hannover sind über die Versorgungs- und Verkehrsgesellschaft Hannover (VVG) mit circa 75 Prozent der Anteile an enercity beteiligt. Weitere 24 Prozent der Anteile hält die Thüga AG, das größte kooperative Netzwerk kommunaler Energie- und Wasserdienstleister in Deutschland.</p>
          <ul class="legend">
            <li>
              <span class="value">75,09%</span>
              <span class="label">Versorgungs- und Verkehrsgesellschaft <br>Hannover mbH (VVG)</span>
            </li>
            <li>
              <span class="value">24,00%</span>
              <span class="label">Thüga Aktiengesellschaft</span>
            </li>
            <li>
              <span class="value">0,91%</span>
              <span class="label">Region Hannover</span>
            </li>
          </ul>
        </div>
      </div>
      <hr>
      <h2>Beteiligungen <br>des enercity-Konzerns</h2>
      <p>Rund 25 Beteiligungen an anderen Unternehmen leisten einen erheblichen Beitrag zum wirtschaftlichen Erfolg und flankieren das traditionelle Kerngeschäft ideal.</p>
      <p>Zudem erweisen sich Energiedienstleistungen wie das Contracting oder der Ausbau erneuerbarer Energien als Wachstumsfelder, die einen wesentlichen Beitrag zu den erfolgreichen Geschäftsergebnissen leisten.</p>
      <div class="shares">
        <div>
          <h3>Erzeugung, Bezug, Speicherung, Handel</h3>
          <ul>
            <li class="wind"><span class="label">enercity Erneuerbare GmbH</span><span class="value">100 % • SK 1,0 Mio. EUR</span></li>
            <li class="heat"><span class="label">enercity Speichervermarktungs&shy;gesellschaft mbH</span><span class="value">100 % • SK 0,025 Mio. EUR</span></li>
            <li class="factory"><span class="label">GKH Hannover GmbH</span><span class="value">84,7 % • SK 10,23 Mio. EUR </span></li>
            <li class="gas"><span class="label">GHG Hannover GmbH</span><span class="value">58,2 % • SK 0,137 Mio. EUR</span></li>
            <li class="wind"><span class="label">WKN GmbH & Co. WP Krempdorf KG</span><span class="value">16,34 % • EL 6,12 Mio. EUR  </span></li>
            <li class="water"><span class="label">Harzwasserwerke GmbH</span><span class="value">7 % • SK 38,5 Mio. EUR </span></li>
            <li class="water"><span class="label">HKW Harzwasser Kommunale WV GmbH</span><span class="value">1,9 % • SK 5,268 Mio. EUR</span></li>
          </ul>
        </div>
        <div>
          <h3>Vertrieb, Verteilung</h3>
          <ul>
            <li class="net"><span class="label">enercity Netz GmbH</span><span class="value">100 % • SK 0,030 Mio. EUR </span></li>
            <li class="net"><span class="label">Netzgesellschaft Laatzen GmbH & Co.KG</span><span class="value">49 % • EL 6,1 Mio. EUR </span></li>
            <li class="net"><span class="label">Gasnetzgesellschaft Laatzen-Nord mbH </span><span class="value">49 % • SK 0,025 Mio. EUR </span></li>
            <li class="net"><span class="label">Netzgesellschaft Seelze GmbH & Co.KG</span><span class="value">49 % • EL 0,025 Mio. EUR</span></li>
            <li class="home"><span class="label">SW Wunstorf GmbH & Co.KG</span><span class="value">34 % • EL 2,0 Mio. EUR </span></li>
            <li class="map"><span class="label">Thüga Holding GmbH & Co.KGaA</span><span class="value">20,53 % • GK 10,0 Mio. EUR </span></li>
            <li class="home"><span class="label">SW Garbsen GmbH</span><span class="value">20 % • SK 17,80 Mio. EUR </span></li>
          </ul>
        </div>
        <div>
          <h3>Dienstleistung, Effizienz</h3>
          <ul>
            <li class="digital"><span class="label">enercity digital GmbH</span><span class="value">100 % • SK 0,025 Mio. EUR</span></li>
            <li class="heat"><span class="label">enercity Contracting GmbH</span><span class="value">100 % • SK 0,21 Mio. EUR </span></li>
            <li class="heat"><span class="label">Danpower GmbH</span><span class="value">100 % • SK 5,0 Mio. EUR </span></li>
            <li class="heat"><span class="label">EPL GmbH</span><span class="value">50 % • SK 0,15 Mio. EUR</span></li>
            <li class="digital"><span class="label">htp GmbH</span><span class="value">50 % • SK 25,0 Mio. EUR</span></li>
            <li class="mobility"><span class="label">wallbe GmbH</span><span class="value">49,4% • SK 0,037 Mio. EUR</span></li>
            <li class="mobility"><span class="label">wallbe Service OGH</span><span class="value">50 % • EL 0,10 Mio. EUR</span></li>
            <li class="pipe"><span class="label">KLH Tiefwerk Holding GmbH</span><span class="value">49 % • SK 0,025 Mio. EUR </span></li>
            <li class="mobility"><span class="label">E2Work GmbH</span><span class="value">37 % • SK 0,025 Mio. EUR </span></li>
            <li class="shop"><span class="label">e.pilot GmbH</span><span class="value">25,1 % • SK 0,09 Mio. EUR </span></li>
            <li class="digital"><span class="label">digimondo GmbH </span><span class="value">25,1 % • SK 0,033 Mio. EUR</span></li>
            <li class="skyscraper"><span class="label">Rockethome GmbH </span><span class="value">16,74 % • SK 0,070 Mio. EUR</span></li>
            <li class="skyscraper"><span class="label">TRIGIS NET GmbH </span><span class="value">49,0 % • SK 0,10 Mio. EUR  </span></li>
            <li class="electricity"><span class="label">enercity-Fonds proKlima GbR</span><span class="value">ca. 75 % • Volumen ca.4,0 Mio. EUR </span></li>
          </ul>
        </div>
        <p class="share-legend"><span>SK= Stammkapital</span><span>EL=Einlage</span><span>GK=Grundkapital</span></p>
      </div>
      <hr class="turned">
      <div class="tables">
        <headline kicker="Unsere Zahlen auf einen Blick" headline="Vergleich Absatz- und Erzeugungs&shy;mengen für das Geschäftsjahr 2020 und das Geschäftsjahr 2019"/>
        <table class="header">
          <tr>
            <td></td>
            <td>Ist 2020</td>
            <td>Ist 2019</td>
            <td><span class="mobile">Abw. / %</span><span class="desktop">Abweichung in %</span></td>
          </tr>
        </table>
        <table>
          <tr>
            <th colspan="4">Netzabsatz</th>
          </tr>
          <tr>
            <td><span class="name">Strom</span><span class="unit">GWh</span></td>
            <td>3.175</td>
            <td>3.403</td>
            <td>-6,7</td>
          </tr>
          <tr>
            <td><span class="name">Gas</span><span class="unit">GWh</span></td>
            <td>8.246</td>
            <td>8.147</td>
            <td>1,2</td>
          </tr>
          <tr>
            <td><span class="name">Fernwärme</span><span class="unit">GWh</span></td>
            <td>1.151</td>
            <td>1.203</td>
            <td>-4,3</td>
          </tr>
          <tr>
            <td><span class="name">Wasser</span><span class="unit">Mio. m³</span></td>
            <td>44</td>
            <td>43</td>
            <td>1,4</td>
          </tr>
        </table>
        <table>
          <tr>
            <th colspan="4">Energiehandel und -vertrieb</th>
          </tr>
          <tr>
            <td><span class="name">Strom</span><span class="unit">GWh</span></td>
            <td>30.390</td>
            <td>19.884</td>
            <td>52,8</td>
          </tr>
          <tr>
            <td><span class="name">Gas</span><span class="unit">GWh</span></td>
            <td>64.907</td>
            <td>60.383</td>
            <td>7,5</td>
          </tr>
          <tr>
            <td><span class="name">Wärme</span><span class="unit">GWh</span></td>
            <td>2.429</td>
            <td>2.517</td>
            <td>-3,5</td>
          </tr>
          <tr>
            <td><span class="name">Wasser</span><span class="unit">Mio. m³</span></td>
            <td>44</td>
            <td>43</td>
            <td>1,4</td>
          </tr>
        </table>
        <table>
          <tr>
            <th colspan="4">Erzeugung (enercity Konzern)</th>
          </tr>
          <tr>
            <td><span class="name">Erzeugung Strom</span><span class="unit">GWh</span></td>
            <td>3.323</td>
            <td>3.264</td>
            <td>1,8</td>
          </tr>
          <tr>
            <td><span class="name">Davon Strom aus Erneuerbaren Energien</span><span class="unit">GWh</span></td>
            <td>1.215</td>
            <td>1.163</td>
            <td>4,5</td>
          </tr>
          <tr class="strong">
            <td><span class="name">Anteil Strom aus erneuerbaren Energien</span><span class="unit">%</span></td>
            <td>36,6</td>
            <td>35,6</td>
            <td></td>
          </tr>
          <tr>
            <td><span class="name">Erzeugung Wärme</span><span class="unit">GWh</span></td>
            <td>2.847</td>
            <td>3.015</td>
            <td>-5,6</td>
          </tr>
          <tr>
            <td><span class="name">Davon Wärme aus Erneuerbaren Energien</span><span class="unit">GWh</span></td>
            <td>542</td>
            <td>451</td>
            <td>20,2</td>
          </tr>
          <tr class="strong">
            <td><span class="name">Anteil Wärme aus Erneuerbaren</span><span class="unit">%</span></td>
            <td>19,0</td>
            <td>15,0</td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="tables">
        <h2>Kurzfassung Gewinn- und Verlustrechnung in Mio. Euro</h2>
        <table class="header add-margin">
          <tr>
            <td></td>
            <td>Ist 2020</td>
            <td>Ist 2019</td>
            <td><span class="mobile">Abw. / %</span><span class="desktop">Abweichung in %</span></td>
          </tr>
        </table>
        <table>
          <tr>
            <td><span class="name">Umsatzerlöse</span></td>
            <td>3.702,2</td>
            <td>3.103,3</td>
            <td>19,3</td>
          </tr>
          <tr>
            <td><span class="name">Bestandsveränderung/ Eigenleistung</span></td>
            <td>1,2</td>
            <td>-1,0</td>
            <td>220,0</td>
          </tr>
          <tr>
            <td><span class="name">Materialaufwand</span></td>
            <td>-3.420,9</td>
            <td>-2.822,9</td>
            <td>21,2</td>
          </tr>
          <tr>
            <td><span class="name">Personalaufwand</span></td>
            <td>-113,8</td>
            <td>-117,9</td>
            <td>-3,5</td>
          </tr>
          <tr>
            <td><span class="name">Übrige betriebliche Aufwendungen</span></td>
            <td>-87,1</td>
            <td>-77,7</td>
            <td>12,1</td>
          </tr>
          <tr>
            <td><span class="name">Übrige betriebliche Erträge</span></td>
            <td>50,5</td>
            <td>68,4</td>
            <td>-26,2</td>
          </tr>
          <tr>
            <td><span class="name">Beteiligungsergebnis</span></td>
            <td>38,2</td>
            <td>29,8</td>
            <td>28,2</td>
          </tr>
          <tr class="strong">
            <td><span class="name">EBITDA</span></td>
            <td>170,3</td>
            <td>182,0</td>
            <td>-6,4</td>
          </tr>
          <tr>
            <td><span class="name">Abschreibungen (inkl. Zuschreibungen) </span></td>
            <td>-53,3</td>
            <td>-44,6</td>
            <td>19,5</td>
          </tr>
          <tr class="strong">
            <td><span class="name">EBIT</span></td>
            <td>117,0</td>
            <td>137,4</td>
            <td>-14,8</td>
          </tr>
          <tr>
            <td><span class="name">Zinsergebnis</span></td>
            <td>-16,8</td>
            <td>-18,9</td>
            <td>-11,1</td>
          </tr>
          <tr class="strong">
            <td><span class="name">Ergebnis vor Steuern</span></td>
            <td>100,2</td>
            <td>118,5</td>
            <td>-15,4</td>
          </tr>
        </table>
      </div>
      <div class="tables">
        <h2>Kurzfassung Bilanz in Mio. Euro</h2>
        <table class="header add-margin">
          <tr>
            <td></td>
            <td>Ist 31.12.20</td>
            <td>Ist 31.12.19</td>
            <td><span class="mobile">Abw. / %</span><span class="desktop">Abweichung in %</span></td>
          </tr>
        </table>
        <table>
          <tr>
            <td><span class="name">Anlagevermögen</span></td>
            <td>1.177,1</td>
            <td>1.189,3</td>
            <td>-1,0</td>
          </tr>
          <tr>
            <td><span class="name">Umlaufvermögen</span></td>
            <td>401,4</td>
            <td>306,3</td>
            <td>31,0</td>
          </tr>
          <tr>
            <td><span class="name">Rechnungsabgrenzungsposten</span></td>
            <td>1,0</td>
            <td>1,3</td>
            <td>-23,1</td>
          </tr>
          <tr class="strong">
            <td><span class="name">Bilanzsumme Aktiva</span></td>
            <td>1.579,5</td>
            <td>1.496,9</td>
            <td>5,5</td>
          </tr>
          <tr>
            <td><span class="name">Eigenkapital</span></td>
            <td>566,6</td>
            <td>534,2</td>
            <td>6,1</td>
          </tr>
          <tr>
            <td><span class="name">Zuschüsse</span></td>
            <td>75,1</td>
            <td>81,3</td>
            <td>-7,6</td>
          </tr>
          <tr>
            <td><span class="name">Rückstellungen</span></td>
            <td>158,4</td>
            <td>143,9</td>
            <td>10,1</td>
          </tr>
          <tr>
            <td><span class="name">Verbindlichkeiten</span></td>
            <td>776,4</td>
            <td>736,3</td>
            <td>5,4</td>
          </tr>
          <tr>
            <td><span class="name">Rechnungsabgrenzungsposten</span></td>
            <td>3,0</td>
            <td>1,2</td>
            <td>150,0</td>
          </tr>
          <tr class="strong">
            <td><span class="name">Bilanzsumme Passiva</span></td>
            <td>1.579,5</td>
            <td>1.496,9</td>
            <td>5,5</td>
          </tr>
        </table>
      </div>
      <div class="tables">
        <h2>Investitionen in Mio. Euro (enercity-Konzern)</h2>
        <table class="header add-margin not-sticky">
          <tr>
            <td></td>
            <td>Ist 2020</td>
            <td>Ist 2019</td>
            <td><span class="mobile">Abw. / %</span><span class="desktop">Abweichung in %</span></td>
          </tr>
        </table>
        <table>
          <tr>
            <td>Gesamtinvestitionen</td>
            <td>173,5</td>
            <td>199,4</td>
            <td>-13,0</td>
          </tr>
        </table>
      </div>
      <div class="tables">
        <h2>Mitarbeiterinnen und Mitarbeiter (enercity-Konzern)</h2>
        <table class="header add-margin not-sticky">
          <tr>
            <td></td>
            <td>Ist 2020</td>
            <td>Ist 2019</td>
            <td><span class="mobile">Abw. / %</span><span class="desktop">Abweichung in %</span></td>
          </tr>
        </table>
        <table>
          <tr>
            <td>Mitarbeiterzahl</td>
            <td>2.981</td>
            <td>2.922</td>
            <td>2,0</td>
          </tr>
        </table>
      </div>
    </div>
    <article-footer image="report/footer.jpg" text-position="center">
      <h3>Mehr Daten und Fakten</h3>
      <p>Sie möchten mehr über die wirtschaftliche Entwicklung des Unternehmens enercity wissen? Unter <a href="https://www.enercity.de/downloads" target="_blank">www.enercity.de/downloads</a> finden Sie den gesamten handelsrechtlichen Jahresabschluss der enercity AG für das Jahr 2020. Außerdem können Sie dort die Jahresabschlüsse der enercity AG der letzten Jahre aufrufen.</p>
    </article-footer>
    <page-footer @scroll-to-top="toTop"/>
  </div>
</template>

<script>
  import PageFooter from "@/components/PageFooter";
  import ReportCover from "@/elements/ReportCover";
  import Headline from "@/elements/Headline";
  import ArticleFooter from "@/elements/ArticleFooter";

  export default {
    name: "PageReport",
    components: {ArticleFooter, Headline, ReportCover, PageFooter},
    methods: {
      toTop() {
        this.$emit('scroll-to-top');
      },
      coverChange(data) {
        this.$emit('cover-change', data);
      }
    },
    emits: ['change-content', 'scroll-to-top', 'cover-change'],
    mounted() {
      this.$emit('change-content', {showContent: true, title: 'Finanzbericht'});
    }
  }
</script>

<style scoped>
  .page {
    position: relative;
    display: block;
    background-color: #fff;
    min-height: 200vh;
    font-weight: 400;
    color: #111C24;
  }
  .container {
    position: relative;
    display: block;
    margin: calc(2.5% + 30px) auto;
    padding: 0 40px;
    max-width: 1020px;
  }
  h5 {
    font-size: 18px;
    font-weight: 700;
  }
  h2 {
    margin: 1.6em -0.05em 0.6em;
    color: #102D61;
  }
  .row {
    display: flex;
    margin: 2.5em 0 6em;
  }
  @media(max-width: 767px) {
    .row {
      margin-bottom: 2.5em;
    }
  }
  .col:first-child {
    flex: 1 1 40%;
    max-width: 45%;
  }
  .col:last-child {
    max-width: 55%;
  }
  .col > p:first-child {
    margin-top: 0;
  }
  .col .image-box {
    max-width: 84%;
    margin: 0 -2%;
  }
  img {
    display: block;
    max-width: 100%;
  }
  hr {
    position: relative;
    display: block;
    width: 1200px;
    max-width: 95vw;
    left: 50%;
    margin: calc(2vw + 30px) 0 calc(3vw + 40px);
    transform: translate(-50%, 0);
    background: transparent;
    border: 0;
    opacity: 0.6;
  }
  hr.turned:before {
    transform: rotate(180deg);
  }
  hr:before {
    content: "";
    position: relative;
    display: block;
    padding-top: 5%;
    background-image: url(../assets/images/report/hr.png);
    background-size: 100%;
  }
  .legend {
    list-style: none;
    padding: 0;
  }
  .legend li {
    position: relative;
    padding-left: 60px;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: -18px 0;
  }
  .legend li:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #102D61;
  }
  .legend li:first-child:before {
    background: linear-gradient(270deg, #FF0000 0%, #990099 100%);
  }
  .legend li:nth-child(2):before {
    background: linear-gradient(100deg, #B1D995 0%, #3ABABA 100%);
  }
  .legend .value {
    display: block;
    font-weight: 700;
    margin-top: 20px;
    color: #102D61;
  }
  .legend li:first-child .value {
    color: #C7125C;
  }
  .legend li:nth-child(2) .value {
    color: #3ABABA;
  }
  .share-legend {
    position: absolute;
    bottom: 21px;
    right: 0;
    margin: 1em 8px;
    min-width: calc(50% - 30px);
  }
  .shares .share-legend span {
    margin: 0 10px;
    display: inline-block;
  }
  .shares {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    color: #102D61;
    font-weight: 500;
    justify-content: space-between;
    margin: 5% 0;
  }
  .shares > div {
    //max-width: 380px;
    min-width: calc(50% - 30px);
  }
  .shares > div:nth-child(2) {
    order: 1;
  }
  .shares > div:nth-child(3) {
    margin-bottom: -100%;
  }
  .shares ul {
    list-style: none;
    padding: 0;
  }
  .shares li {
    position: relative;
    padding-left: 70px;
    min-height: 66px;
    padding-top: 5px;
    line-height: 1.3;
    margin-bottom: 12px;
  }
  .shares li:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #102D61;
    margin-left: -2px;
  }
  .shares li.digital:before {
    background-image: url(../assets/icons/digital.svg);
  }
  .shares li.electricity:before {
    background-image: url(../assets/icons/electricity.svg);
  }
  .shares li.factory:before {
    background-image: url(../assets/icons/factory.svg);
  }
  .shares li.gas:before {
    background-image: url(../assets/icons/gas.svg);
  }
  .shares li.heat:before {
    background-image: url(../assets/icons/heat.svg);
  }
  .shares li.home:before {
    background-image: url(../assets/icons/home.svg);
  }
  .shares li.map:before {
    background-image: url(../assets/icons/map.svg);
  }
  .shares li.mobility:before {
    background-image: url(../assets/icons/mobility.svg);
  }
  .shares li.net:before {
    background-image: url(../assets/icons/net.svg);
  }
  .shares li.pipe:before {
    background-image: url(../assets/icons/pipe.svg);
  }
  .shares li.shop:before {
    background-image: url(../assets/icons/shop.svg);
  }
  .shares li.skyscraper:before {
    background-image: url(../assets/icons/skyscraper.svg);
  }
  .shares li.water:before {
    background-image: url(../assets/icons/water.svg);
  }
  .shares li.wind:before {
    background-image: url(../assets/icons/wind.svg);
  }
  .shares span {
    display: block;
  }
  .shares h3 {
    position: relative;
    display: flex;
    align-items: flex-end;
    font-size: 22px;
    line-height: 1.3;
    font-weight: 500;
    padding-bottom: 0.7em;
    padding-right: 20%;
    min-height: 72px;
    margin-bottom: 1.4em;
  }
  .shares h3:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    border-radius: 2px;
    background-color: #102D61;
  }
  .tables h2 {
    margin-top: 2.5em;
    margin-bottom: 0.5em;
    font-size: 36px;
  }
  @media(max-width: 480px) {
    .tables h2 {
      font-size: 8vw;
    }
  }
  table {
    width: 100%;
    border-spacing: 0;
    font-size: 18px;
    color: #9A989C;
    margin-bottom: 4%;
  }
  .unit {
    float: right;
  }
  .header {
    position: sticky;
    top: 100px;
    background-color: white;
    margin-top: 6%;
    z-index: 1;
    padding-top: 10px;
    border-bottom: 3px solid #102D61;
    margin-bottom: 2px;
  }
  .header.not-sticky {
    position: relative;
    top: auto;
  }
  .add-margin {
    margin-bottom: 14px;
  }
  .header td {
    font-weight: 500 !important;
    color: #102D61 !important;
  }
  .header + table tr:first-child th:before {
    display: none;
  }
  .strong td {
    border-bottom: 1px solid #9A989C;
    color: #111C24;
    font-weight: 500;
    padding-bottom: 18px;
  }
  .strong + tr td {
    padding-top: 18px;
  }
  th, td {
    text-align: left;
    padding: 6px 0;
    border: 0;
    font-weight: 400;
    vertical-align: top;
  }
  th {
    font-weight: 500;
    color: #102D61;
  }
  th:before, th:after {
    content: "";
    position: relative;
    display: block;
    height: 3px;
    background-color: #102D61;
    border-radius: 2px;
    margin: 10px 0 6px;
  }
  th:before {
    margin: 6px 0 11px;
  }
  th:first-child, td:first-child {
    width: 52%;
  }
  th:nth-child(2), td:nth-child(2) {
    width: 14%;
    text-align: right;
    font-weight: 700;
  }
  th:nth-child(3), td:nth-child(3) {
    width: 14%;
    text-align: right;
    font-weight: 700;
    color: #3ABABA;
  }
  th:nth-child(4), td:nth-child(4) {
    width: 20%;
    text-align: right;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .header {
      top: 70px;
    }
  }
  @media(max-width: 999px) {
    .container {
      padding: 0 34px;
    }
    .shares > div {
      max-width: 46%;
      min-width: calc(50% - 20px);
    }
    .header {
      top: 84px;
    }
    table {
      font-size: 17px;
    }
  }
  @media(min-width: 1000px) {
    .header .mobile {
      display: none;
    }
  }
  @media(max-width: 999px) {
    .header .desktop {
      display: none;
    }
  }
  @media(max-width: 767px) {
    table {
      font-size: 13px;
    }
    th, td {
      padding: 3px 0;
    }
    th:after, th:before {
      height: 2px;
      margin: 6px 0;
    }
    .header {
      top: 64px;
      font-size: 10px;
      line-height: 1.2;
      font-weight: 700;
      border-bottom: 2px solid #102D61;
    }
    th:nth-child(1), td:nth-child(1) {
      width: 49%;
    }
    th:nth-child(2), td:nth-child(2),
    th:nth-child(3), td:nth-child(3),
    th:nth-child(4), td:nth-child(4) {
      width: 17%;
    }
  }
  @media(max-width: 567px) {
    h5 {
      font-size: 16px;
    }
    .row {
      display: block;
      margin-top: 1.5em;
    }
    .row .col {
      max-width: 100%;
    }
    .row .col:last-child {
      display: flex;
      flex-direction: column;
    }
    .col .image-box {
      max-width: 200px;
    }
    .legend {
      order: -1;
      margin: 28px 0;
    }
    .legend .label {
      font-size: 14px;
    }
    .legend br {
      display: none;
    }
    .container {
      padding: 0 20px;
    }
    .share-legend {
      position: relative;
      display: block;
      right: auto;
      bottom: auto;
      margin-left: -8px;
      order: 2;
    }
    .shares > div {
      max-width: 100%;
      min-width: 100%;
      float: none !important;
    }
    .shares > div:nth-child(3) {
      margin-bottom: 0;
    }
    .shares h3 {
      font-size: 20px;
      min-height: 0;
    }
    .shares li {
      padding-left: 62px;
      margin-bottom: 4px;
    }
  }
</style>
